import { Utils } from 'cc-common';
import * as moment from 'moment-timezone';

export class ValidationFormatConstants {
    static emailPattern =
        /^(?!.*?\.\.)(?:[ ]*(?:[^\W.])[A-Za-z0-9-._%'+#-]*@(?:[A-Za-z0-9-._]+)(?:\.[A-Za-z]{2,})+[ ]*)$/;
    static phonePattern = /^\s*\(?\s*[0-9]\d{2}\)?-?\s*\d{3}\s*-?\s*\d{4}$/;
    static zipPattern = /^\d{5}(?:[-\s]\d{4})?$/;
    static webUrlPattern =
        /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
    static urlPattern = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z]{2,})+(?:\/[^/\s]*)*$/i;
    static phoneRules: any = { X: /[02-9]/ };
    static rnumPattern = /^R[0-9]{7}[U,L]{1}[0-9]{7}$/;
    static usernamePattern = /^[a-z0-9_\.@!]+$/;
    static numberPattern = /\d+/g;
    static alphaNumPattern = /[a-zA-Z0-9]+/g;
}

export const dateJSONTransformer = (raw: Date) => {
    return !!raw ? moment(raw).format('YYYY-MM-DD') : raw;
};

export const alphaNumericTransform = (value: string): string => {
    return Utils.notNullOrEmpty(value)
        ? (value.match(ValidationFormatConstants.alphaNumPattern) || []).join('').trim()
        : value;
};

export const phoneNumberTransformer = (value: string): string => {
    return Utils.notNullOrEmpty(value)
        ? (value.match(ValidationFormatConstants.numberPattern) || []).join('').split('').slice(0, 10).join('').trim()
        : value;
};
